import { render, staticRenderFns } from "./AbstractResult.vue?vue&type=template&id=5dcdb323&scoped=true&"
import script from "./AbstractResult.vue?vue&type=script&lang=js&"
export * from "./AbstractResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcdb323",
  null
  
)

export default component.exports